// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/content_blocks" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementContentBlocks } from "./constants";
import type { EngagementContentBlocksParams, EngagementContentBlocksResult } from "./types";
import { isEngagementContentBlocksResult } from "./validators";

export const getDataTableEngagementContentBlocks = reactQueryTableFetcherAdapter(
  engagementContentBlocks,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
      include_html = false,
      include_grapes_js_data = false,
    }: EngagementContentBlocksParams
  ): Promise<EngagementContentBlocksResult> => {
    return fetch(
      "/engagement/content_blocks",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        include_html,
        include_grapes_js_data,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isEngagementContentBlocksResult
);
